export const AccountType = {
  BASIS: 0,
  ADVANCED: 1,
  HOSPITAL: 2,
  ADJUSTMENT: 3,
  MYOPIA: 4,
}

export const CONTENT_TYPE = {
  DOWNLOAD: 0,
  IMAGE: 1,
  VIDEO: 2,
  ARTICLE: 3,
  TAG: 4,
}

export const PAGE_TYPE = {
  LOGIN: 0,
  HOME: 1,
  DOWNLOAD: 2,
  PRODUCT: 3,
  HELP: 4,
  ACCOUNT: 5,
  OTHER: 6,
}
